import { useEffect, useState } from 'react'
import Dashboard from '../../components/Dashboard'
import ProductosTable from '../../components/Productos/Table'
import useFetchHome from '../../hooks/useFetchHome'
import { getProductos } from '../../services/productos/productos'
import { Button, TextField, Box } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import DownloadIcon from '@mui/icons-material/Download'

const esc = (v: any) => `"${String(v ?? '').replace(/"/g, '""')}"`
const bool = (v: any) => (v === '1' || v === 1 || v === true) ? 'Sí' : 'No'

const exportarCSV = (productos: any[]) => {
    const headers = [
        'ID', 'Nombre', 'SKU', 'Categoría', 'Subcategoría',
        'Descripción', 'Activo', 'Destacado', 'Visitas',
        'Link Amazon', 'Link MercadoLibre', 'Video',
        'Meta Tags', 'Imagen Principal', 'Infografía',
        'Título Complementario', 'Descripción Complementaria', 'Imagen Complementaria',
        'Label Descargable', 'Categoría Descargable', 'ID Descargable',
    ]
    const rows = productos.map(p => [
        esc(p.id),
        esc(p.nombre),
        esc(p.sku),
        esc(p.categoria),
        esc(p.subcategoria),
        esc(p.descripcion),
        bool(p.activo),
        bool(p.destacado),
        p.visitas || 0,
        esc(p.link_amazon),
        esc(p.link_ml),
        esc(p.video),
        esc(p.meta_tags),
        esc(p.imagen_principalUrl),
        esc(p.infografiaUrl),
        esc(p.titulo_complementario),
        esc(p.descripcion_complementaria),
        esc(p.imagen_complementariaUrl),
        esc(p.labelDescargable),
        esc(p.descargableCategoria),
        esc(p.idDescargable),
    ])
    const csv = [headers.join(','), ...rows.map(r => r.join(','))].join('\n')
    const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = `productos_${new Date().toISOString().slice(0, 10)}.csv`
    a.click()
    URL.revokeObjectURL(url)
}

const ProductosPage = () => {

    const [productos, setProductos] = useState<any[]>([])
    const [productosFiltrados, setProductosFiltrados] = useState<any[]>([])
    const [filtroBusqueda, setFiltroBusqueda] = useState('')
    const {home} = useFetchHome()
    const navigate = useNavigate()

    const fetchProductos = async () => {
      const productosDB = await getProductos()
      setProductos(productosDB)
      setProductosFiltrados(productosDB)
    }

    useEffect(() => {
      fetchProductos()
    },[])


    useEffect(() => {
      if (filtroBusqueda.trim() === '') {
        setProductosFiltrados(productos)
      } else {
        const filtrados = productos.filter(producto => 
          producto.nombre.toLowerCase().includes(filtroBusqueda.toLowerCase()) ||
          producto.sku.toLowerCase().includes(filtroBusqueda.toLowerCase())
        )
        setProductosFiltrados(filtrados)
      }
    }, [filtroBusqueda, productos])

    

  return (
    <Dashboard>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        margin:'2% 0'
      }}>
      <h1>PRODUCTOS</h1>
      
      
      <Box sx={{ display: 'flex', gap: '12px' }}>
        <Button variant='outlined' startIcon={<DownloadIcon />} style={{
             marginBottom: '20px',
            background: '#000',
            fontFamily: 'WorkSans',
            fontWeight: '500',
            fontSize: '14px',
            lineHeight: '16px',
            textAlign: 'center',
            textTransform: 'uppercase',
            color: '#FFF',
            padding: '17px 62px',
            border: 'none',
            cursor: 'pointer',
          }} onClick={() => exportarCSV(productosFiltrados)}>
          Exportar CSV
        </Button>
        <Button variant='contained' color='success' style={{
            marginBottom: '20px',
            background: '#000',
            fontFamily: 'WorkSans',
            fontWeight: '500',
            fontSize: '14px',
            lineHeight: '16px',
            textAlign: 'center',
            textTransform: 'uppercase',
            color: '#FFF',
            padding: '17px 62px',
            border: 'none',
            cursor: 'pointer',
          }} onClick={() => {
            navigate("/producto/nuevo")
          }} >
            Nuevo Producto
          </Button>
      </Box>
      </div>

      <Box sx={{ marginBottom: '20px', maxWidth: '400px' }}>
        <TextField
          fullWidth
          label="Buscar por nombre o SKU"
          variant="outlined"
          value={filtroBusqueda}
          onChange={(e) => setFiltroBusqueda(e.target.value)} 
          placeholder="Ingresa el nombre del producto o SKU..."
        />
      </Box>

      {/* Información de resultados */}
      <Box sx={{ marginBottom: '10px', fontSize: '14px', color: '#666' }}>
        {filtroBusqueda.trim() !== '' 
          ? `Mostrando ${productosFiltrados.length} de ${productos.length} productos`
          : `Total: ${productos.length} productos`
        }
      </Box>
      
        <ProductosTable productos={productosFiltrados} home={home} onDelete={fetchProductos} />
    </Dashboard>
  )
}

export default ProductosPage